import { Observable } from 'rxjs'

import { request, parseAPIError, DownloadRequest } from '../../common/api'

import * as actionTypes from './actionTypes'
import * as actionCreators from './actionCreators'
import * as tableModelActionTypes from '../../common/table/actionTypes'
import { resolveModelState } from '../../common/table/helpers'

// Fetch

const fetchReportDriverHourlyOverviewEpic = (action$, store) => {
    const tableIdentifier = 'report_driver_hourly_overview'

    return action$
        .ofType(actionTypes.FETCH, tableModelActionTypes.CONFIGURATION_CHANGED)
        .filter(action => action.type !== tableModelActionTypes.CONFIGURATION_CHANGED || action.payload.tableIdentifier === tableIdentifier)
        .switchMap(action => {
            const modelState = resolveModelState(tableIdentifier, store.getState(), action)

            return Observable.concat(
                Observable.of({
                    type: actionTypes.FETCH_STARTED,
                }),
                request({
                    method: 'POST',
                    path: `report-driver-hourly-overview`,
                    body: {
                        filters: modelState.get('filters').toJS(),
                    },
                })
                    .switchMap(ajaxResponse => Observable.of(actionCreators.fetchReportDriverHourlyOverviewFulfilled(ajaxResponse.response)))
                    .catch(error => Observable.of(actionCreators.fetchReportDriverHourlyOverviewRejected(parseAPIError(error))))
                    .takeUntil(action$.ofType(actionTypes.FETCH_CANCELLED, actionTypes.FETCH))
            )
        })
}

// Export

const exportReportDriverHourlyOverviewEpic = (action$, store) =>
    action$.ofType(actionTypes.EXPORT).switchMap(action => {
        const filters = JSON.stringify(action.payload)
        const token = store.getState().auth.get('accessToken')

        new DownloadRequest({
            url: `report-driver-hourly-overview/export?filters=${filters}&token=${token}`,
        }).run()

        return Observable.concat(
            Observable.of({
                type: actionTypes.EXPORT_FULFILLED,
            })
        )
    })


// Fetch details

const fetchReportDriverHourlyOverviewDetailsEpic = (action$, store) =>
    action$.ofType(actionTypes.FETCH_DETAILS).switchMap(action =>{
        const tableIdentifier = 'report_driver_hourly_overview'
        const modelState = resolveModelState(tableIdentifier, store.getState(), action)

        return Observable.concat(
            Observable.of({
                type: actionTypes.FETCH_DETAILS_STARTED,
            }),
            request({
                method: 'POST',
                path: `report-driver-hourly-overview/details`,
                body: {
                    driver_id: action.payload.driverId,
                    date_from: action.payload.dateFrom,
                    date_to: action.payload.dateTo,
                    filters: modelState.get('filters').toJS(),
                },
            })
                .switchMap(ajaxResponse => Observable.of(actionCreators.fetchReportDriverHourlyOverviewDetailsFulfilled(ajaxResponse.response)))
                .catch(error => Observable.of(actionCreators.fetchReportDriverHourlyOverviewDetailsRejected(parseAPIError(error))))
                .takeUntil(action$.ofType(actionTypes.FETCH_DETAILS_CANCELLED))
        )
    })


// Export details

const exportReportDriverHourlyOverviewDetailsEpic = (action$, store) =>
    action$.ofType(actionTypes.EXPORT_DETAILS).switchMap(action => {
        const token = store.getState().auth.get('accessToken')

        new DownloadRequest({
            url: `report-driver-hourly-overview/details/export?driver_id=${action.payload.driverId}&date_from=${action.payload.dateFrom}&date_to=${action.payload.dateTo}&filters=${JSON.stringify({ ...action.payload.filters })}&token=${token}`,
        }).run()

        return Observable.concat(
            Observable.of({
                type: actionTypes.EXPORT_DETAILS_FULFILLED,
            })
        )
    })

export default [fetchReportDriverHourlyOverviewEpic, exportReportDriverHourlyOverviewEpic, fetchReportDriverHourlyOverviewDetailsEpic, exportReportDriverHourlyOverviewDetailsEpic]